<template>
<div
    v-bind:innerHTML.prop="textLocal"
    :contenteditable="!disabled"
    v-on:blur="updateCode"
    @keyup.ctrl.delete="$emit('delete-row')"
    :placeholder="placeholder"
    ></div>
</template>
<script>
  import * as DOMPurify from 'dompurify';
  export default {
      props: { value: String, placeholder: String, disabled: Boolean, striphtml: {type: Boolean, default: false} },
      methods: {
        updateCode: function($event) {
          this.$vnode.child._vnode.data.domProps['innerHTML'] = $event.target.innerHTML;
          this.$emit('input', $event.target.innerHTML);
          if(this.striphtml){
            this.$emit('textchange', this.convertToPlain($event.target.innerHTML));
          }else{
            this.$emit('textchange', $event.target.innerHTML);
          }
        
        },
        convertToPlain: function(html){
            return _.trim(DOMPurify.sanitize(html, {ALLOWED_TAGS: ['%text', 'div']}).replaceAll('<div></div>','').replaceAll('<div>','').replaceAll('</div>','\n').replaceAll('&nbsp;', " "));
        },
        convertToHtml: function(text){
          var sanitizedText = _.trim(DOMPurify.sanitize(text, {ALLOWED_TAGS: ['%text', 'div']}).replaceAll('<div>','').replaceAll('</div>','\n').replaceAll('&nbsp;', " "));;
          return sanitizedText.split("\n").map(function(token){return "<div>" + token + "</div>";}).join("").replaceAll('<div></div>','');
        }
      },
      model: {
          prop: 'value',
          event: 'textchange'
      },
      computed:{
        textLocal: {
          get: function(){
            return this.convertToHtml(this.value)
          },
          set: function(value){
            this.$emit('textchange', value)
          },
        }
      }
  }
</script>
<style scoped>
div {
  min-height: 32px;
  line-height: 1.15;
  background-color: white !important;
  border-radius: 4px !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: rgb(140, 140, 140) !important;
  padding: 5px !important;
}
.emptycontent {
  color:  black;
}
div:empty:not(:focus):before {
    content: attr(placeholder);
    color: black; 
}
div:focus-visible{
  outline:  0px !important;
  outline-style: auto !important;
  outline-width: 0px !important;
}
div:empty:focus::before {
    content: "";
}
div[placeholder]:empty:before {
    content: attr(placeholder);
    color: #ddd; 
}
</style>